import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import useIdleLogout from '../hooks/useIdleLogout';

const navAdmin = [
  { label: 'Dashboard',        icon: '📊', to: '/' },
  { section: 'Finanças' },
  { label: 'Transações',       icon: '💳', to: '/transacoes' },
  { label: 'Transferências',   icon: '🔄', to: '/transferencias' },
  { label: 'Recorrências',     icon: '🔁', to: '/recorrencias' },
  { section: 'Contas' },
  { label: 'Contas Bancárias', icon: '🏦', to: '/contas' },
  { label: 'Cartões de Crédito', icon: '💳', to: '/cartoes' },
  { section: 'Planejamento' },
  { label: 'Orçamentos',       icon: '📋', to: '/orcamentos' },
  { label: 'Metas',            icon: '🎯', to: '/metas' },
  { section: 'Análise' },
  { label: 'Relatórios',       icon: '📈', to: '/relatorios' },
  { label: 'Extrato',          icon: '📄', to: '/extrato' },
  { section: 'Configurações' },
  { label: 'Categorias',       icon: '🏷️', to: '/categorias' },
  { label: 'Usuários',         icon: '👥', to: '/sub-usuarios' },
  { label: 'Meu Perfil',       icon: '👤', to: '/perfil' },
];

const navViewer = [
  { label: 'Extrato',    icon: '📄', to: '/extrato' },
  { section: 'Conta' },
  { label: 'Meu Perfil', icon: '👤', to: '/perfil' },
];

export default function Layout({ children, title }) {
  const { usuario, logout, isViewer } = useAuth();
  const navigate = useNavigate();
  const nav = isViewer ? navViewer : navAdmin;
  useIdleLogout();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  const initials = usuario?.nome?.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase() || 'U';

  return (
    <div className="app-layout">
      {/* Overlay mobile */}
      {sidebarOpen && (
        <div
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 99 }}
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <span className="logo-icon">💰</span>
          <div>
            <div className="logo-text">Controle</div>
            <div className="logo-sub">Financeiro Pessoal</div>
          </div>
        </div>

        <nav className="sidebar-nav" onClick={() => setSidebarOpen(false)}>
          {nav.map((item, i) =>
            item.section ? (
              <div key={i} className="nav-section">{item.section}</div>
            ) : (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) => isActive ? 'active' : ''}
              >
                <span className="nav-icon">{item.icon}</span>
                {item.label}
              </NavLink>
            )
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="user-avatar" style={{ background: usuario?.avatar_cor || '#2563eb' }}>
              {initials}
            </div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 600, color: 'white', fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {usuario?.nome}
              </div>
              <div style={{ fontSize: 11, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {usuario?.email}
              </div>
            </div>
          </div>
          <button onClick={handleLogout}>🚪 Sair</button>
        </div>
      </aside>

      <div className="main-content">
        {isViewer && (
          <div style={{
            background: '#fef3c7', borderBottom: '1px solid #f59e0b',
            padding: '6px 20px', fontSize: 12, color: '#92400e',
            display: 'flex', alignItems: 'center', gap: 6,
          }}>
            <span>👁️</span>
            <span>Modo visualização — você está vendo dados de conta(s) compartilhada(s). Nenhuma alteração é permitida.</span>
          </div>
        )}
        <header className="topbar">
          <button
            className="btn btn-ghost btn-icon mobile-menu-btn"
            onClick={() => setSidebarOpen(true)}
            aria-label="Menu"
          >☰</button>
          <h1 className="topbar-title">{title}</h1>
        </header>
        <main className="page-body">{children}</main>
      </div>
    </div>
  );
}
